export const GET_MY_PROGRAMS = "GET_MY_PROGRAMS";
export const GET_BANNER_FOR_DASHBOARD = "GET_BANNER_FOR_DASHBOARD";
